/**
 * Operate with keyboard.
 *
 * @module keyboard
 */

'use strict';


/**
 * Open keyboard through core intent.
 *
 * @param {Object} config - keyboard config
 * @param {Function} [callback] - invoked on successful result
 */
module.exports = function ( config, callback ) {
    core.intent({
        action: 'keyboard',
        data: {
            title: config.title,
            value: config.value
        },
        events: {
            done: function ( event ) {
                var targetElem = config.elemSelector;

                if ( callback ) {
                    callback(event);
                }

                targetElem.innerText = event.value || targetElem.parentNode.parentNode.data.value.defaultValue;
            }
        }
    }, function ( error ) {
        console.log(error);
    });
};
